import React, { useRef } from 'react';
import PropTypes from 'prop-types';

export default function FloatingNavButton({ id, icon, label, onClick, expandedButton, setExpandedButton }) {
  const isExpanded = expandedButton === id;
  const leaveTimer = useRef(null);
  const expandedButtonRef = useRef(expandedButton);
  expandedButtonRef.current = expandedButton;

  const handleMouseEnter = () => {
    clearTimeout(leaveTimer.current);
    setExpandedButton(id);
  };

  const handleMouseLeave = () => {
    leaveTimer.current = setTimeout(() => {
      if (expandedButtonRef.current === id) {
        setExpandedButton(null);
      }
    }, 150);
  };

  return (
    <button
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0.75rem',
        gap: 0,
        backgroundColor: '#F16D09',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        fontSize: '1rem',
        // Only animate width — avoids competing layout recalcs from padding/justifyContent
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        width: isExpanded ? '200px' : '50px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
      aria-label={label}
    >
      {/* Fixed-width container keeps icon centred in the 50px collapsed state */}
      <span style={{
        fontSize: '1.2rem',
        width: '26px',
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
      }}>
        {icon}
      </span>
      {/* Always in the DOM — no conditional render mid-transition */}
      <span style={{
        fontSize: '0.9rem',
        marginLeft: '0.5rem',
        flexShrink: 0,
        opacity: isExpanded ? 1 : 0,
        // Slight delay so the label fades in after the button has started opening
        transition: 'opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0.1s',
      }}>
        {label}
      </span>
    </button>
  );
}

FloatingNavButton.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  expandedButton: PropTypes.string,
  setExpandedButton: PropTypes.func.isRequired,
};
